<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div class="full-page-bg-color" slot="no-body">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img alt="login" class="mx-auto" :src="require('@/assets/images/logo/logo.png')">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center bg-white">
                            <form class="p-8" @submit="e => e.preventDefault()">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Autenticar</h4>
                                    <p>Seja bem-vindo, por favor informe seu e-mail e senha.</p>
                                </div>
                                <vs-input autofocus :color="errors.has('email') ? 'danger' : 'success'"
                                          class="w-full mb-6 no-icon-border" icon="icon icon-user"
                                          icon-pack="feather" label-placeholder="E-mail" name="email"
                                          v-model="form.email"
                                          v-validate="'required|email'"
                                />
                                <span class="text-danger">{{ errors.first('email') }}</span>
                                <vs-input class="w-full mb-4 no-icon-border" icon="icon icon-lock" icon-pack="feather"
                                          label-placeholder="Senha" name="senha"
                                          type="password" v-model="form.senha"
                                          v-validate="'required|min:6'"/>
                                <span class="text-danger">{{ errors.first('senha') }}</span>
                                <!--<div class="flex flex-wrap justify-between my-5">
                                    <vs-checkbox class="mb-3" v-model="form.lembrar">Lembrar</vs-checkbox>
                                    <router-link to="/pages/forgot-password">Esqueci a senha?</router-link>
                                </div>-->
                                <div class="flex flex-wrap justify-center my-5">
                                    <VueRecaptcha
                                        ref="recaptcha"
                                        :sitekey="siteKey"
                                        @verify="handleRecaptchaVerify"
                                        @expired="handleRecaptchaExpired"/>
                                </div>
                                <div class="flex flex-wrap justify-end my-5">
                                    <vs-button @click="validate" class="float-right">Entrar</vs-button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import { VueRecaptcha } from 'vue-recaptcha';

    export default {
        components: { VueRecaptcha },
        data() {
            return {
                form: {
                    email: '',
                    senha: '',
                    tk: '',
                    lembrar: false,
                },
            }
        },
        computed: {
            siteKey: function () {
                return process.env.VUE_APP_RECAPTCHA_SITE_KEY;
            }
        },
        methods: {
            ...mapActions(['login', 'logout']),
            handleRecaptchaVerify(data) {
                this.form.tk = data;
            },
            handleRecaptchaExpired() {
                this.form.tk = '';
                console.log('Captcha expired!')
            },
            validate() {
                this.$validator.validateAll().then(result => {
                    if (result) this.auth();
                })
            },
            setAxiosToken(authToken) {
                this.$axios.interceptors.request.use(config => {
                    config.headers['Authorization'] = `Bearer ${authToken}`;
                    return config;
                });
            },
            auth() {
                this.$axios.post('/auth/login', this.form).then(async ({data}) => {
                    const {token: authToken, me: user} = data;

                    this.setAxiosToken(authToken);

                    this.login({
                        authToken,
                        user
                    });
                    this.$router.push(this.$route.query.redirect || "/");
                }).catch(({message}) => {
                    this.$vs.notify(
                        {
                            title: 'Erro',
                            text: message,
                            color: "rgb(242, 19, 93)",
                            position: 'top-right',
                            time: 5000
                        }
                    )
                    this.$refs.recaptcha.reset();
                })
            }
        }
    }
</script>
